var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{staticClass:"cloudrec-chip",attrs:{"color":_vm.color,"text-color":"white","small":""},on:{"click":_vm.open}},[_c('v-avatar',{staticClass:"teal"},[_c('v-icon',[_vm._v("file_download")])],1),_vm._v(" "+_vm._s(_vm.title)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }